import { type ComponentChildren } from 'preact';
import * as stylex from '@stylexjs/stylex';
import { styles } from './badge.styles';
export type BadgeVariant = 'green' | 'gray' | 'warn' | 'danger' | 'info';
interface BadgeProps {
  variant?: BadgeVariant;
  children: ComponentChildren;
}
export function Badge({
  variant = 'gray',
  children
}: BadgeProps) {
  return <span {...stylex.props(styles.base, styles[variant])}>{children}</span>;
}